<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qP6WBs/tc-custom/9781784380380.jpg?1705405193845" alt="This image is the cover for the book On The Road With Wellington, The Napoleonic Library"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On The Road With Wellington, The Napoleonic Library
      </h1>
      <p class="bookDescription body article font2">
        <p>As a classic work and out of print for many years, August Schaumann''s diaries provide a graphic and vivi d account of campaigning life during the Peninsular Wars.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        August Ludolf Friedrich Schaumann, Bernard Cornwell
      </h2>
      
      <p class="authorDescription body article">SCHAUMANN was born in Hanover and at the age of 16 he was compelled to join the army against his will, but he eventually rose through the ranks to the rank of junior-subaltern, though he left the Hanoverian Army in 1799. When France invaded Hanover in 1803 Schaumann went to England where he was employed as a clerk at a Newcastle firm. In 1807 he decided to move to Russia. He never made it there because heavy storms forced him to take refuge in Goteborg, Sweden. Here too he found a brief employment as a clerk. When the English fleet sailed back to England after its Swedish expedition in 1808 August he boarded one of its ships and was taken to England to start a new career as war commissary in the King's German Legion.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64c6a61c